module.exports = "6e5303f881698e88256ee820d7f531fe.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/laser emitter.png
// module id = 71
// module chunks = 0